import { render, staticRenderFns } from "./UnshippedData.vue?vue&type=template&id=9059fc50&scoped=true&"
import script from "./UnshippedData.vue?vue&type=script&lang=js&"
export * from "./UnshippedData.vue?vue&type=script&lang=js&"
import style0 from "./UnshippedData.vue?vue&type=style&index=0&id=9059fc50&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9059fc50",
  null
  
)

export default component.exports